import { render, staticRenderFns } from "./SetUpDialog.vue?vue&type=template&id=56be42ee&scoped=true"
import script from "./SetUpDialog.vue?vue&type=script&lang=js"
export * from "./SetUpDialog.vue?vue&type=script&lang=js"
import style0 from "./SetUpDialog.vue?vue&type=style&index=0&id=56be42ee&prod&lang=sass&scoped=true"
import style1 from "./SetUpDialog.vue?vue&type=style&index=1&id=56be42ee&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56be42ee",
  null
  
)

export default component.exports